import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import { FieldFactory } from 'client/shared/components';
import { inject } from 'mobx-react';
import { addStore } from 'client/shared/react-util';
import {toast} from 'react-toastify';
import { UserGrid } from './user-grid';
import userStore from '../../../shared/stores/user-store';
import ConfirmButton from 'common/components/confirm-button';

const UserForm = (({userStore, formStore,}) => {
    const { id } = useParams();
    const [modalOpen, setModalOpen] = useState(false);
    const history = useHistory();
    const FieldWithStore = addStore(FieldFactory, { formStore });
    

    let user = userStore.items.find(item => item._id === id);
    console.log(user)
    return (
        <div>
            <button className="margin-top-1 margin-bottom-0 button neo super-small" onClick={() => history.push('/manage-users')}>Back</button>
            <div className="grid-x" style={{alignItems: 'center'}}>
                <div className="grid-x">
                    <h1>{user.firstName} {user.lastName}</h1>
                </div>
                <div className="padding-top-1 margin-left-3 grid-x">
                    <ConfirmButton
                        warningText={ `Really delete ${user.firstName} ${user.lastName}?` }
                        onConfirmClick={ 
                            async () => {
                                try {
                                    await userStore.deleteItem(user);
                                    toast.success(`${user.firstName} ${user.lastName} was deleted successfully.`);
                                    history.push('/manage-users')
                                } catch (err) {
                                    toast.error(`An error occured while deleting ${user.firstName} ${user.lastName}.`);
                                    console.error('[ERROR DELETING USER]', err);
                                }
                            }
                        }
                    >
                    </ConfirmButton>
                </div>
            </div>
            <div className="grid-x margin-top-1">
                <div className="small-12 large-4 cell">
                    <div className="margin-bottom-1">
                        <FieldWithStore
                            item={ user }
                            fieldKey="user.firstName"
                            onChange={ user.save }
                        />
                    </div>
                    <div className="margin-bottom-1">
                        <FieldWithStore
                            item={ user }
                            fieldKey="user.lastName"
                            onChange={ user.save }
                        />
                    </div>
                    <div className="margin-bottom-1">
                        <FieldWithStore
                            item={ user }
                            fieldKey="user.userName"
                            onChange={ user.save }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
})


const injectWithStores = inject('userStore', 'formStore');

export default injectWithStores(
    ({userStore, formStore}) => {
        return (
            <UserForm userStore={userStore} formStore={formStore}/>
        )
    })